import { deleteIcon, minus, plus } from '../../assets/svgs'
// import FlatButtons from '../FlatButton/FlatButton'
import Typography from '../Typography/Typography'
import styles from './style.module.css'
import { useState } from 'react'

interface cartProp {
    id?: string | number
    name?: string
    category?: string
    stockNumber?: string | number
    colour?: string
    price?: number | string
    image?: string
    initialQuantity?: number | string
    onQuantityChange?: (id: number | string, quantity: number) => void
    onRemove?: (id: number | string) => void
}

export const CartContent: React.FC<cartProp> = ({
    id = 1,
    name = "Wireless Bluetooth Headphones",
    category = "shoe",
    stockNumber = 7,
    colour = "Black",
    price = 89.99,
    image = "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=200&h=200&fit=crop&crop=center",
    initialQuantity = 1,
    onQuantityChange = () => { },
    onRemove = () => { }
}) => {

    const [quantity, setQuantity] = useState(Number(initialQuantity))

    const handleQuantityChange = (newQuantity: number) => {
        if (newQuantity >= 1) {
            setQuantity(newQuantity);
            onQuantityChange(id, newQuantity);
        }
    };

    const handleRemove = () => {
        onRemove(id);
        console.log(id)
    };

    const subtotal: string = (Number(price) * quantity).toFixed(2);

    return (
        <div className={styles.container}>

            <div className={styles.itemQuantity}>

                <div className={styles.itemWrapper}>

                    <div className={styles.imgContainer}>

                        <img className={styles.img} src={image} alt="" />

                    </div>

                    <div className={styles.detailContainer}>

                        <div className={styles.detailName}>

                            <Typography
                                variant='heading5'
                                // size='base'
                                className={styles.detailNameText}
                            >
                                {name}
                            </Typography>

                        </div>

                        <div className={styles.detailCategory}>

                            <Typography

                                className={styles.detailCategoryText}
                            >
                                {category}
                            </Typography>

                        </div>

                        <div className={styles.detailColourStock}>

                            <Typography className={styles.detailColour}>
                                {colour}
                            </Typography>

                            <Typography className={styles.detailStock}>
                                {stockNumber}
                            </Typography>

                        </div>

                    </div>

                </div>

                <div className={styles.quantityContainer}>

                    <button
                        className={styles.quantityBtn}
                        onClick={() => { handleQuantityChange(quantity - 1) }}
                    >
                        <img src={minus} alt="" />
                    </button>

                    <Typography
                        className={styles.quantityNumber}
                    >
                        {quantity}
                    </Typography>

                    <button
                        className={styles.quantityBtn}
                        onClick={() => { handleQuantityChange(quantity + 1) }}
                    >
                        <img src={plus} alt="" />
                    </button>

                </div>

            </div>

            <div className={styles.priceDelete}>

                <div className={styles.priceContainer}>

                    <Typography
                        variant='heading4'
                        className={styles.priceText}
                    >
                        {`$${subtotal}`}
                    </Typography>

                </div>

                <div className={styles.deleteContainer}>

                    <button
                        className={styles.deleteBtn}
                        onClick={() => { handleRemove() }}
                    >
                        <img src={deleteIcon} alt="" />
                    </button>

                </div>

            </div>


        </div>
    )
}